import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { changeDashboardAlertsFilterEpic } from './_epics/changeDashboardAlertsFilter.epic';
import { changeDashboardAlertsFromEpic } from './_epics/changeDashboardAlertsFrom.epic';
import { changeDashboardAlertsToEpic } from './_epics/changeDashboardAlertsTo.epic';
import { initDashboardAlertsFilterEpic } from './_epics/initDashboardAlertsFilter.epic';
import { loadAlertListEpic } from './_epics/loadAlertList.epic';
import { pollingDashboardAlertsEpic } from './_epics/pollingDashboardAlerts.epic';
import { persistAlertsPollingEpic } from './_epics/persistAlertsPolling.epic';

export const alertsDashboardEpic = safeCombineEpics(
  changeDashboardAlertsFilterEpic,
  changeDashboardAlertsFromEpic,
  changeDashboardAlertsToEpic,
  initDashboardAlertsFilterEpic,
  loadAlertListEpic,
  pollingDashboardAlertsEpic,
  persistAlertsPollingEpic,
);
